export const translation = 
{
    "header": {
      "tagline": "BetSlip"
    },
    "tabs": {
        "tab1": "Straight",
        "tab2": "Parlay"
    },
    "straight_content": {
      "button": "Clear this bet from BetSlip",
    },
    "parlay_content": {
      'total': "Leg Parlay",
    },
    "books_list": {
      "heading": "Compare books from the list below",
      "table_col_parlay": "Odds*",
      "table_col_straight": "Total Wager*",
      "table_col_2": "To Win",
      "disclaimer": "*Sportbooks may not offer all odds.",
      "compare_more": "Compare more odds",
      "compare_less": "Compare less odds",
      "cta": "Sign up",
      "cta_quickBet": "Bet now"
    },
    "wager_card": {
      "label": "Wager",
      "payout": "To Win"
    },
    "footer": {
        "button": "Clear old Bets from BetSlip",
        "cta": "Bet at ",
        "cta_quickBet": "Quick Bet at ",
        "total": "Total to win"
    },
    "empty_message": {
      "heading": "Your BetSlip is empty, add selections to get you started.",
      "description": "Organize your bets while you research and compare 'To Win' amounts for different books.",
      "footnote": "*This slip is not an integrated betting feature"
    },
    "empty_parlay_message": {
      "heading": "You need at least 2 selections for a Parlay Bet",
      "description": "A Parlay is a bet on two or more teams. You can combine different sports, points, spreads and money lines. To win the parlay bet all selections must win.",
    },
    "warning_messages": {
      "maximun_selection": "You can only add a maximum of 12 legs",
      "same_game_parlay": "Same Game Parlay odds can not be calculated",
      "match_in_progress": "Your games have already started",
      "different_partners": "Your selections are not from the same sportsbook. We've picked the best odds from your selected sportsbooks."
    },
    "modal": {
      "betslip_cta": "Add to BetSlip",
      "betslip_cta_disabled": "View in BetSlip"
    },
    "pop_up_modal": {
      "heading": "Check out our new free BetSlip feature!",
      "features": [
        "Organize your BetSlip while you research",
        "Add bets from multiple leagues",
        "Find the best payouts for straight bets and parlays",
        "Transfer your BetSlip from Covers to a sportsbook in seconds with [LOGO]"
      ],
      "description": "[ICON] Look for this icon in the sportsbook list",
      "disclaimer": "*Participating sportsbooks only. Only available in regulated states.",
      "cta": "Try it now"
    },
    "system_messages": {
      "api_connection": {
        "heading": "System Error",
        "description": "The API connection has failed. Please our contact IT team."
      }
    },
  }